/**
 * Created by razial on 04.04.2024
 */

const SdkManager = function () {
    ConnectorEventEmitter.call(this);

    this.ready = {};
    this.loading = {};
};

SdkManager.prototype = Object.create(ConnectorEventEmitter.prototype);
SdkManager.prototype.constructor = SdkManager;

SdkManager.prototype.loadSdk = function (name, callback) {
    const loader = SdkManager.LOADERS[name];
    if (!loader) {
        callback(connector.CODE_FAILED);
        return;
    }

    if (this.ready[name]) {
        callback(connector.CODE_SUCCEED);
        return;
    }

    if (this.loading[name]) {
        this.loading[name].push(callback);
        return;
    }

    this.loading[name] = [callback];

    const onComplete = function (code) {
        if (code === connector.CODE_SUCCEED) {
            this.ready[name] = true;
            console.log(`SdkManager initialize ${name} sdk done`);
        } else {
            console.log(`SdkManager initialize ${name} sdk failed`);
        }

        const listeners = this.loading[name];
        this.loading[name] = undefined;

        listeners.forEach((callback) => {
            try {
                callback(code);
            } catch (e) {
                setTimeout(() => {
                    throw e;
                }, 0);
            }
        });
    }.bind(this);

    console.log(`SdkManager loading ${name} sdk started`);

    const player = new ConnectorActionPlayer(loader);
    player.onSuccess(onComplete.bind(this, connector.CODE_SUCCEED));
    player.onFailure(onComplete.bind(this, connector.CODE_FAILED));
    player.play();
};

SdkManager.timeout = function (timeout, step) {
    return function (success, failure) {
        setTimeout(failure, timeout);
        step(success, failure);
    };
};

SdkManager.once = function (step) {
    return function (success, ...args) {
        if (step) {
            const oldStep = step;
            step = undefined;
            oldStep.call(this, success, ...args);
        } else {
            success();
        }
    };
};

SdkManager.load = function (url, options) {
    return function (success, failure) {
        connector.utils.loadSdk(url, {
            onSuccess: success,
            onFailure: failure,
            crossorigin: options && options.crossorigin
        });
    };
};

SdkManager.SDK_TEST = "test";
SdkManager.SDK_CRAZY = "crazy";
SdkManager.SDK_DRAUGIEM = "draugiem";
SdkManager.SDK_FOTOSTRANA = "fotostrana";
SdkManager.SDK_GDCOM = "gdcom";
SdkManager.SDK_INSTANT = "instant";
SdkManager.SDK_KONGREGATE = "kongregate";
SdkManager.SDK_MSSTART = "msstart";
SdkManager.SDK_MYMAILRU = "mymailru";
SdkManager.SDK_OK = "ok";
SdkManager.SDK_PLINGA = "plinga";
SdkManager.SDK_SAMSUNG = "samsung";
SdkManager.SDK_SPMOBAGE = "spmobage";
SdkManager.SDK_VK = "vk";
SdkManager.SDK_YANDEX = "yandex";
SdkManager.SDK_XSOLLA = "xsolla";
SdkManager.SDK_GOOGLE_ADS = "google_ads";
SdkManager.SDK_XIAOMI = "xiaomi";
SdkManager.SDK_YANDEX_WEB_ADS = "yandex_web_ads";
SdkManager.SDK_DISCORD = "discord";
SdkManager.SDK_TELEGRAM = "telegram";
SdkManager.SDK_REDDIT = "reddit";
SdkManager.SDK_TIKTOK = "tiktok";
SdkManager.SDK_ARKADIUM = "arkadium";
SdkManager.SDK_ADDICTINGGAMES = "addicting";
SdkManager.SDK_POGO = "pogo";

SdkManager.LOADERS = {};

SdkManager.LOADERS[SdkManager.SDK_TEST] = [
    function (success) {
        setTimeout(success, 2000);
    }
];

SdkManager.LOADERS[SdkManager.SDK_CRAZY] = [
    SdkManager.once(SdkManager.load("//sdk.crazygames.com/crazygames-sdk-v3.js")),

    (success, failure) => {
        if (typeof CrazyGames !== "undefined") {
            success();
        } else {
            failure();
        }
    },

    (success, failure) => {
        const started = Date.now();

        CrazyGames.SDK.init().then(() => {
            if (CrazyGames.SDK.environment !== "disabled") {
                success();
                return;
            }

            if (!SdkManager.crazyDisabledReported) {
                SdkManager.crazyDisabledReported = true;

                const ancestors = location.ancestorOrigins ? Array.from(location.ancestorOrigins).join(" < ") : "unknown";

                connector.utils.throwAsync({
                    group: "crazy_disabled",
                    message: `init: ${Date.now() - started}ms framed: ${window !== window.top} ancestors: ${ancestors || "none"} referrer: ${document.referrer}`
                });
            }

            failure();
        }).catch(failure);
    }
];

SdkManager.LOADERS[SdkManager.SDK_DRAUGIEM] = [
    SdkManager.load("//draugiem.lv/applications/external/draugiem.js", {
        crossorigin: false
    }),

    function (success) {
        // eslint-disable-next-line camelcase
        draugiem_callback_url = `${connector.calcBaseUrl()}res/draugiem/callback.html`;
        // eslint-disable-next-line camelcase
        draugiem_domain = "www.draugiem.lv";

        success();
    }
];

SdkManager.LOADERS[SdkManager.SDK_FOTOSTRANA] = [
    SdkManager.load(connector.utils.getRequestParameters().fsapi, {
        crossorigin: false
    }),

    function (success) {
        // eslint-disable-next-line new-cap
        window.FSClient = new fsapi(connector.config.fotostrana.appId, connector.config.fotostrana.privateKey);
        FSClient.init(() => {
            console.log("API Error!");
        });
        success();
    }
];

SdkManager.LOADERS[SdkManager.SDK_GDCOM] = [
    SdkManager.once((success) => {
        window.GD_OPTIONS = {
            gameId: connector.config[connector.info.hybrid ? "gdcomhybrid" : "gdcom"].appId,
            onEvent: function (event) {
                console.log(SdkManager.SDK_GDCOM, "sdk event", event);
                connector.sdk.trigger(SdkManager.SDK_GDCOM, event);

                if (event && event.name === "SDK_READY") {
                    SdkManager.sdkReady = true;

                    if (SdkManager.onSdkReady) {
                        SdkManager.onSdkReady();
                        delete SdkManager.onSdkReady;
                    }
                }
            }
        };

        success();
    }),

    SdkManager.load("//html5.api.gamedistribution.com/main.min.js"),

    SdkManager.timeout(10000, (success) => {
        if (SdkManager.sdkReady) {
            success();
        } else {
            SdkManager.onSdkReady = success;
        }
    })
];

SdkManager.LOADERS[SdkManager.SDK_REDDIT] = [
    SdkManager.timeout(10000, (success) => {
        if (window.redditsdk) {
            success();
        } else {
            window.onRedditSDKReady = success;
        }
    })
];

SdkManager.LOADERS[SdkManager.SDK_INSTANT] = [
    SdkManager.load("//connect.facebook.net/en_US/fbinstant.8.0.js"),

    SdkManager.timeout(60000, (success, failure) => {
        try {
            FBInstant.initializeAsync().then(() => {
                const onCompleteCallback = connector.utils.waitNoMore(30000, () => {
                    clearInterval(waitUserInterval);
                    success();
                });

                const waitUserInterval = setInterval(() => {
                    if (FBInstant.player.getID()) {
                        onCompleteCallback();
                    }
                }, 100);
            }).catch(failure);
        } catch (e) {
            failure(e);
        }
    })
];

SdkManager.LOADERS[SdkManager.SDK_KONGREGATE] = [
    SdkManager.load("//cdn1.kongregate.com/javascripts/kongregate_api.js", {
        crossorigin: false
    }),

    SdkManager.timeout(10000, (success) => {
        kongregateAPI.loadAPI(() => {
            window.kongregate = kongregateAPI.getAPI();
            success();
        });
    })
];

SdkManager.LOADERS[SdkManager.SDK_MSSTART] = [
    SdkManager.load("//assets.msn.com/staticsb/statics/latest/msstart-games-sdk/msstart-v1.0.0-rc.21.min.js", {
        crossorigin: false
    })
];

SdkManager.LOADERS[SdkManager.SDK_TELEGRAM] = [
    SdkManager.load("https://telegram.org/js/telegram-web-app.js?56")
];

SdkManager.LOADERS[SdkManager.SDK_MYMAILRU] = [
    SdkManager.load("//connect.mail.ru/js/loader.js", {
        crossorigin: false
    }),

    SdkManager.timeout(10000, (success) => {
        mailru.loader.require("api", () => {
            mailru.app.init(connector.config.mm.privateKey);
            success();
        });
    })
];

SdkManager.LOADERS[SdkManager.SDK_OK] = [
    function (success) {
        window.API_callback = function (method, result, data) {
            console.log("sdk", method, result, data);
            connector.sdk.trigger(SdkManager.SDK_OK, method, result, data);
        };
        success();
    },

    SdkManager.load("//api.ok.ru/js/fapi5.js", {
        crossorigin: false
    }),

    SdkManager.timeout(60000, (success, failure) => {
        const rParams = FAPI.Util.getRequestParameters();

        const run = (attempt = 1) => {
            FAPI.init(
                rParams.api_server,
                rParams.apiconnection,
                () => success(),
                () => {
                    if (attempt <= 5) {
                        setTimeout(() => run(attempt + 1), 500);
                    } else {
                        failure();
                    }
                }
            );
        };

        run();
    })
];

SdkManager.LOADERS[SdkManager.SDK_PLINGA] = [
    SdkManager.load("//s3.amazonaws.com/imgs3.plinga.de/general/easyXDM.min.js"),

    function (success) {
        easyXDM.DomHelper.requiresJSON("//s3.amazonaws.com/imgs3.plinga.de/general/json2.min.js");
        success();
    },

    SdkManager.load("//s3.amazonaws.com/imgs3.plinga.de/plingaRpc/plingaRpc.js"),

    SdkManager.timeout(10000, (success) => {
        plingaRpc.init(success);
    })
];

SdkManager.LOADERS[SdkManager.SDK_SAMSUNG] = [
    // must be in index.html
    // <script src="https://gtg.samsungapps.com/gsinstant-sdk/gsinstant.0.46.js"> </script>
    // <script src="https://img.samsungapps.com/gsinstant-sdk/iapinstant.1.0.js"> </script>

    SdkManager.timeout(10000, (success, failure) => {
        GSInstant.initializeAsync().then(success).catch(failure);
    })
];

SdkManager.LOADERS[SdkManager.SDK_SPMOBAGE] = [
    function (success, failure) {
        const sdkPath = connector.config.debugMode
            ? "https://cdn-sb-connect.mobage.jp/jssdk/mobage-jssdk-client.3.10.1.min.js"
            : "https://cdn-connect.mobage.jp/jssdk/mobage-jssdk-client.3.10.1.min.js";

        document.addEventListener("mobageReady", success);

        connector.utils.loadSdk(sdkPath, {
            onSuccess: function () {
                setTimeout(failure, 10000);
            },
            onFailure: failure,
            crossorigin: false
        });
    },

    function (success, failure) {
        try {
            mobage.init({
                clientId: SPMobageSocial.getClientId(),
                redirectUri: SPMobageSocial.getRedirectUrl()
            });
            success();
        } catch (e) {
            failure();
        }
    }
];

SdkManager.LOADERS[SdkManager.SDK_VK] = [
    function (success, failure) {
        if (typeof vkBridge !== "undefined") {
            success();
        } else {
            SdkManager.load("//unpkg.com/@vkontakte/vk-bridge/dist/browser.min.js")(success, failure);
        }
    },

    SdkManager.timeout(10000, (success, failure) => {
        vkBridge.send("VKWebAppInit", {}).then(success).catch(() => {
            if (vkBridge.isWebView()) {
                vkBridge.donate(101);
            }
            failure();
        });
    }),

    SdkManager.once((success) => {
        vkBridge.subscribe((event) => {
            const detail = event && event.detail || {};

            console.log("vkBridge response", detail);
            connector.sdk.trigger(SdkManager.SDK_VK, detail.type, detail.data);
        });
        success();
    })
];

SdkManager.LOADERS[SdkManager.SDK_YANDEX] = [
    function (success, failure) {
        if (typeof Promise === "undefined") {
            connector.utils.loadSdk("//cdn.jsdelivr.net/bluebird/latest/bluebird.core.min.js", {
                onSuccess: success,
                onFailure: failure
            });
        } else {
            success();
        }
    },

    SdkManager.load("//sdk.games.s3.yandex.net/sdk.js"),

    SdkManager.timeout(10000, (success, failure) => {
        if (typeof YaGames === "undefined" || typeof YaGames.init !== "function") {
            failure();
            return;
        }

        YaGames.init().then((ysdk) => {
            window.ysdk = ysdk;
            success();
        }).catch(failure);
    })
];

SdkManager.LOADERS[SdkManager.SDK_XSOLLA] = [
    SdkManager.load("//cdn.xsolla.net/payments-bucket-prod/embed/1.5.4/widget.min.js")
];

// the game's script only document.writeln()s the tag of the MiGames SDK, which a loaded page ignores: that tag is added here
SdkManager.LOADERS[SdkManager.SDK_XIAOMI] = [
    function (success, failure) {
        document.writeln = function (html) {
            delete document.writeln;

            const template = document.createElement("template");
            template.innerHTML = html;

            const script = document.createElement("script");
            Array.from(template.content.firstChild.attributes).forEach((attr) => script.setAttribute(attr.name, attr.value));
            script.onload = success;
            script.onerror = failure;
            document.head.appendChild(script);
        };

        connector.utils.loadSdk(`https://cdn.alsgp0.fds.api.mi-img.com/global-game/partner/micp/${connector.config.xiaomi.sdk}.js`, {
            onFailure: failure
        });
    }
];

SdkManager.LOADERS[SdkManager.SDK_GOOGLE_ADS] = [
    function (success, failure) {
        const { client } = connector.config.adsense;

        const attrs = {
            "data-ad-client": client,
            "data-ad-frequency-hint": "5s"
        };

        if (connector.config.debugMode) {
            attrs["data-adbreak-test"] = "on";
        }

        connector.utils.loadSdk(`//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`, {
            attrs,
            onSuccess: success,
            onFailure: failure
        });
    },

    SdkManager.once((success) => {
        window.adsbygoogle = window.adsbygoogle || [];

        window.adsbygoogle.push({
            preloadAdBreaks: "on",
            sound: "on",
            onReady: function () {
                window.googleadsReady = true;

                if (window.googleadsOnReady) {
                    window.googleadsOnReady();
                    delete window.googleadsOnReady;
                }

                connector.sdk.trigger(SdkManager.SDK_GOOGLE_ADS, "ready");
            }
        });

        success();
    }),

    SdkManager.timeout(10000, (success) => {
        if (window.googleadsReady) {
            success();
        } else {
            window.googleadsOnReady = success;
        }
    })
];

SdkManager.LOADERS[SdkManager.SDK_YANDEX_WEB_ADS] = [
    function (success, failure) {
        window.yaContextCb = window.yaContextCb || [];

        connector.utils.loadSdk("https://yandex.ru/ads/system/context.js", {
            onSuccess: success,
            onFailure: failure
        });
    }
];

SdkManager.LOADERS[SdkManager.SDK_DISCORD] = [
    // must be in index.html
    // <script src="discord-1.9.0.3.min.js"></script>

    SdkManager.timeout(10000, (success, failure) => {
        window.discordSdk = new DiscordSDK(connector.config.discord.appId);
        window.discordSdk.ready().then(success).catch(failure);
    })
];

SdkManager.LOADERS[SdkManager.SDK_TIKTOK] = [
    SdkManager.timeout(10000, (success) => {
        const check = (attempt = 1) => {
            if (typeof TTMinis !== "undefined") {
                success();
            } else if (attempt < 100) {
                setTimeout(() => check(attempt + 1), 100);
            }
        };

        check();
    })
];

SdkManager.LOADERS[SdkManager.SDK_ADDICTINGGAMES] = [
    function (success, failure) {
        window.ramp = window.ramp || {};
        window.ramp.que = window.ramp.que || [];
        window.ramp.passiveMode = true;

        SdkManager.load("//cdn.intergient.com/1025278/74978/ramp.js", { crossorigin: false })(success, failure);
    },

    SdkManager.timeout(15000, (success) => {
        const check = (attempt = 1) => {
            if (attempt > 150) {
                return;
            }

            if (window.ramp && window.ramp.que) {
                window.ramp.que.push(() => {
                    window.ramp.spaNewPage(window.location.pathname);
                    success();
                });
            } else {
                setTimeout(() => check(attempt + 1), 100);
            }
        };

        check();
    })
];

SdkManager.LOADERS[SdkManager.SDK_ARKADIUM] = [
    SdkManager.load("https://developers.arkadium.com/cdn/sdk/v2/sdk.js"),

    SdkManager.timeout(10000, (success) => {
        const check = (attempt = 1) => {
            if (attempt > 100) {
                return;
            }

            if (typeof window.ArkadiumGameSDK === "undefined") {
                setTimeout(() => check(attempt + 1), 100);
                return;
            }

            window.ArkadiumGameSDK.getInstance().then((sdk) => {
                window.ArkadiumSDK = sdk;
                success();
            }).catch(() => setTimeout(() => check(attempt + 1), 100));
        };

        check();
    })
];

SdkManager.LOADERS[SdkManager.SDK_POGO] = [
    SdkManager.once((success) => {
        window.pogoSdk = new PogoSDK({
            gameId: connector.config.pogo.gameId,
            gameCode: connector.config.pogo.gameCode
        });

        success();
    }),

    SdkManager.timeout(10000, (success, failure) => {
        window.pogoSdk.ready().then(success).catch(failure);
    })
];
